import { render, staticRenderFns } from "./BusinessInternetPage.vue?vue&type=template&id=4a4e9858&scoped=true&"
import script from "./BusinessInternetPage.vue?vue&type=script&lang=js&"
export * from "./BusinessInternetPage.vue?vue&type=script&lang=js&"
import style0 from "./BusinessInternetPage.vue?vue&type=style&index=0&id=4a4e9858&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4e9858",
  null
  
)

export default component.exports